import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "angular2-social-login";
import {ApiService} from "../services/api.service";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";
import {MalihuScrollbarService} from "ngx-malihu-scrollbar";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";
import {HeaderComponent} from "../header/header.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-eat-drink-single',
    templateUrl: './eat-drink-single.component.html'
})
export class EatDrinkSingleComponent implements OnInit, AfterViewInit {
    restaurant: any;
    slug: string;
    reviews_avg: any;
    rating_order: any;
    reviews: any;
    next: string;
    menu: any;
    seatingAreas: any;

    // google map
    zoom = 16;

    lat: number;
    lng: number;

    markers = {
        'experiences': [],
        'properties': []
    };
    map_tab;

    infoWindow = null;

    galleryOptions = [
        {
            width: '800px',
            height: '750px',
            thumbnailsColumns: 4,
            imagePercent: 80,
            thumbnailsPercent: 17,
            thumbnailsMargin: 5,
            thumbnailMargin: 5
        },
    ];
    galleryImages: Array<any>;
    facilities: Array<any>;
    auth_user: User;

    nearby_tab: string;
    nearby: any;

    navleft = '<i class="icon-angle-left"></i>';
    navright = '<i class="icon-angle-right"></i>';

    headersHeight: number;

    constructor(public header: HeaderComponent,
                private api: ApiService,
                private router: Router,
                private modalService: NgbModal,
                public share: ShareButtons,
                private route: ActivatedRoute,
                private auth: AuthServices,
                public _auth: AuthService,
                private authService: AuthServices,
                private ref: ChangeDetectorRef) {

        this.slug = route.snapshot.paramMap.get('slug');
        this.galleryImages = [];
        this.facilities = [];
        this.nearby_tab = 'attractions';
        this.map_tab = 'experiences';
        this.nearby = {
            'attractions': [],
            'shopping': [],
            'art-entertainment': [],
            'eat-drink': [],
            'hotels': []
        };
    }

    ngOnInit() {
        this.getAuthUser();
        this.getRestaurant();
        this.getRestaurantImages();
        this.getNearby();
        this.getSeatingAreas();
    }

    ngAfterViewInit(): void {
        this.headersHeight = $(window).width() > 991 ? $('#header').height() + $('div.fixed-nav').height() : $('.nav-parent').height();
        this.ref.detectChanges();
    }

    getRestaurant(): void {
        this.api
            .getRestaurantBySlug(this.slug)
            .subscribe(res => {
                if (res['results'].length) {
                    this.restaurant = res['results'][0];

                    this.lat = this.restaurant.latitude = parseFloat(this.restaurant.latitude);
                    this.lng = this.restaurant.longitude = parseFloat(this.restaurant.longitude);
                    this.infoWindow = 'current';

                    this.getRestaurantFacilities(this.restaurant.id);
                    this.getReviews();
                    this.getMenu(this.restaurant.id);
                } else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            });
    }

    getReviews(type: string = 'All'): void {
        let url = `${Conf.API_URL}/restaurant-reviews/?restaurant__slug=${this.slug}`;
        let url_avg = `${Conf.API_URL}/restaurant-reviews-avg/?restaurant=${this.restaurant.id}`;
        if (type !== 'All') {
            url += '&sort=' + type;
            url_avg += '&sort=' + type;
        }

        this.api
            .getRestaurantReviewsAvg(url_avg)
            .subscribe(
                res => {
                    this.reviews_avg = res['results'];
                    this.rating_order = res['rating_order'];
                },
                err => console.log(err)
            );

        this.api
            .getRestaurantReviews(url)
            .subscribe(
                res => {
                    this.reviews = res['results'];
                    this.next = res['next'];
                },
                err => console.log(err)
            );

    }

    getRestaurantImages(): void {
        this.api
            .getRestaurantImages(this.slug)
            .subscribe(
                res => {
                    res['results'].forEach(value => {
                        this.galleryImages.push({
                            small: value.image,
                            medium: value.image,
                            big: value.image
                        });
                    });
                },
                err => console.log(err)
            );
    }

    getRestaurantFacilities(id: number): void {
        this.api
            .getRestaurantFacilities(id)
            .subscribe(
                res => {
                    this.facilities = res['results'];
                },
                err => console.log(err)
            );
    }

    getAuthUser(): void {
        this.auth
            .currentUser
            .subscribe((user: User) => this.auth_user = user);
    }

    loadMore(): void {
        this.api
            .loadMore(this.next)
            .subscribe(
                res => {
                    this.reviews = this.reviews.concat(res['results']);
                    this.next = res['next'];
                },
                error => console.log(error.error)
            );
    }

    selectMapTab(tab) {
        this.map_tab = tab;
        this.lat = this.restaurant.latitude;
        this.lng = this.restaurant.longitude;
        this.infoWindow = 'current';
    }

    openLogin() {
        this.header.openLogin();
    }

    clickedMarker(category: string, item: any) {
        this.lat = parseFloat(item.latitude);
        this.lng = parseFloat(item.longitude);
        this.infoWindow = category + item.id;
    }

    getNearby(): void {
        this.api
            .getNearby(this.slug)
            .subscribe(
                res => {
                    this.nearby = res['results'];
                    const self = this;
                    $.each(this.nearby, function (category, things) {
                        $.each(things, function (index, value) {
                            if (category == 'current') {
                                self.markers['properties'].push({
                                    index: index,
                                    lat: parseFloat(value.latitude),
                                    lng: parseFloat(value.longitude),
                                    area: value.area,
                                    id: category + value.id,
                                    category: category,
                                    distance: value.distance,
                                    gm_distance: value.gm_distance,
                                    title: value.title,
                                    image: value.thumbnail_image,
                                });
                            } else {
                                self.markers['experiences'].push({
                                    index: index,
                                    lat: parseFloat(value.latitude),
                                    lng: parseFloat(value.longitude),
                                    area: value.area,
                                    id: category + value.id,
                                    category: category,
                                    title: value.title,
                                    image: value.thumbnail_image,
                                    distance: value.distance,
                                    gm_distance: value.gm_distance,
                                });
                            }
                        });
                    });
                },
                err => console.log(err)
            );
    }

    setTabActive($event): void {
        $('li.tab-link a').removeClass('active');
        $event.target.classList.add('active');
        if ($(window).width() < 991) {
            $('ul.toggle-content').slideToggle();
        }
    }

    getCurrencyByPriceCategory(currency: string, priceCategory: number) {
        return currency.repeat(priceCategory);
    }

    getNearbyLinks(tab: string, item: any): string {
        switch (tab) {
            case 'attractions':
                return `/attractions/${item.slug}`;
            case 'shopping':
                return `/shopping/${item.slug}`;
            case 'hotels':
                return `/accommodations/${item.categories.category_slug}/${item.slug}`;
            default:
                return '/404';
        }
    }

    getMenu(id: number): void {
        this.api
            .getRestaurantMenu(id)
            .subscribe(
                res => this.menu = res['results'],
                err => console.log(err)
            );
    }

    getSeatingAreas(): void {
        this.api
            .getSeatingAreas(this.slug)
            .subscribe(
                res => this.seatingAreas = res['results'],
                err => console.log(err)
            );
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/eat-drink-single/eat-drink-single.component.ts